import { render, staticRenderFns } from "./SettingsPrintVersion.vue?vue&type=template&id=5ae0123a&"
import script from "./SettingsPrintVersion.vue?vue&type=script&lang=js&"
export * from "./SettingsPrintVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports